'use strict';

import React, { Component } from "react";
import ReactDOM from "react-dom";
import PicsApi from '../includes/PicsApi';
// ctspritepath is located in CTBase.cshtml file

const routeAlertEffectName = 'Service Change';

class AlertHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            alerts: [],
            dismissed: []
        };

        window.addEventListener('storage', () => {
            this.setState(getAlerts());
        });
   }

    _setState = (state) => {
        setAlerts({ ...this.state, ...state });
    }

    componentDidMount = () => {
        this.callApi();
    };

    callApi = () => {
        let { dismissed } = getAlerts();

        fetch('/restapi/bannernotifications/' + (window.location.pathname.slice(1).split('/')[0] || 'home') + '?format=json')
            .then(response => response.json())
            .then(results => {
                const r = results.Results;
                let alerts = [];

                if (r && r.length) {
                    r.forEach(a => {
                        if (!dismissed.find(d => d.AlertId === a.AlertId && (!d.expires || d.expires > (new Date()).getTime()) ) ) {
                            alerts.push({
                                ...a,
                                DisplayDate: (new Date(parseInt(a.DisplayDate.substr(6)))).toLocaleString().replace(/\:00 /, ' '),
                                isExpanded: (r.length == 1)
                            });
                        }
                    });
                }

                if (!alerts.length) {
                    document.getElementById('system-alerts').remove();
                }

                this._setState({
                    alerts,
                    dismissed
                });
            })
            .catch(error => {
                this._setState({
                    alerts: [],
                    dismissed
                });
            });
    };

    alertOnClick(e, alert) {
        this._setState({ alerts: this.state.alerts.map(a => { if (a.AlertId === alert.AlertId) a.isExpanded = !a.isExpanded; return a; }) });
    }

    dismissAllAlerts(e) {
        this.state.alerts.map(alert => { this.alertDismiss(e, alert) });
    }

    alertDismiss(e, alert) {
        e.preventDefault();
        let dismiss = { AlertId: alert.AlertId }
        this.state.alerts = this.state.alerts.filter(a => a.AlertId !== alert.AlertId);

        if (alert.DismissBehavior === 'Yes Dismiss Reappear') {
            dismiss.expires = (new Date()).getTime() + (60 * 60 * 1000);
        }

        this.state.dismissed.push(dismiss);
        this.state.dismissed = this.state.dismissed.filter(d => !d.expires || d.expires > (new Date()).getTime());
        this._setState(this.state);
    }

    renderModalList() {
        return this.state.alerts.map(alert => {
            let icon = '';
            switch (alert.Priority) {
                case 'alerts-block Urgent':
                    icon = <svg role="img" aria-label="Urgent"><use xlinkHref={ctspritepath + '#alert-new'}></use></svg>
                    break;
                case 'alerts-block Caution':
                    icon = <svg role="img" aria-label="Caution"><use xlinkHref={ctspritepath + '#caution'}></use></svg>
                    break;
                case 'alerts-block Info':
                    icon = <svg role="img" aria-label="Info"><use xlinkHref={ctspritepath + '#info-bell'}></use></svg>
                    break;

            }
            return (
                <div className={alert.Priority + ' open'}>
                    <h6 className="pr-4">{icon} {alert.Title}</h6>
                    <div dangerouslySetInnerHTML={{ __html: alert.Description }} />
                    <div className="alert-actions">
                        {alert.DismissBehavior !== 'No Dismiss' && this.state.alerts.length > 1 &&
                        (<a href="#" className={alert.ButtonClass} onClick={e => this.alertDismiss(e, alert)}>Dismiss</a>)}
                        {alert.LearnMoreUrl &&
                        (<input type="submit" className="button learn-more" onClick={e => window.location = alert.LearnMoreUrl} value="Learn more" />)}
                    </div>
                    {alert.DisplayDateAndTime && (<div>{alert.DisplayDate}</div>) }
                </div>
            );
        });
        
    }

    renderList() {
        let title = '';
        let icon = '';
        let alertDismissBehavior = '';
        let separator = '<span class="alert-title-separator">•</span>';
        switch (this.state.alerts[0].Priority) {
            case 'alerts-block Urgent':
                icon = <svg role="img" aria-label="Urgent"><use xlinkHref={ctspritepath + '#alert-new'}></use></svg>
                break;
            case 'alerts-block Caution':
                icon = <svg role="img" aria-label="Caution"><use xlinkHref={ctspritepath + '#caution'}></use></svg>
                break;
            case 'alerts-block Info':
                icon = <svg role="img" aria-label="Info"><use xlinkHref={ctspritepath + '#info-bell'}></use></svg>
                break;
        }
        if (this.state.alerts.some(i => i.DismissBehavior === 'No Dismiss')) {
            alertDismissBehavior = 'No Dismiss';
            
        }
        else if (this.state.alerts.some(i => i.DismissBehavior === 'Yes Dismiss Reappear')) {
            alertDismissBehavior = 'Yes Dismiss Reappear';
        }
        else {
            alertDismissBehavior = 'Yes Dismiss No Reappear';
        }

        this.state.alerts.map(alert => {
            if (title == '') {
                title = alert.Title
            }
            else {
                title = title + separator + alert.Title;
            }
        });

        if (alertDismissBehavior !== 'No Dismiss') {
            return (
                <div className={this.state.alerts[0].Priority}><a class="alert-main-link" href="#system-alerts-modal" data-toggle="modal">
                    <div class="alert-inner-link">{icon}<div class="alert-inner-link-text"><span class="alerts-titles" dangerouslySetInnerHTML={{ __html: title }} /><span class="alert-slash">|</span><span class="alert-learn-more">Learn More</span></div></div></a>
                    <div class="alert-close">
                        <a href="#" onClick={e => this.dismissAllAlerts(e)}><svg role="img" aria-label="Info"><use xlinkHref={ctspritepath + '#close'}></use></svg></a></div>
                </div>
        )}
        else
            return(
                <div className = { this.state.alerts[0].Priority } ><a class="alert-main-link" href="#system-alerts-modal" data-toggle="modal">
                    <div class="alert-inner-link">{icon}<div class="alert-inner-link-text"><span class="alerts-titles" dangerouslySetInnerHTML={{ __html: title }} /><span class="alert-slash">|</span><span class="alert-learn-more">Learn More</span></div></div></a>
                </div>
            )};

    render() {
        if (!this.state.alerts || !this.state.alerts.length) {
            return null;
        }
        const { alerts } = this.state;

        return (
            <React.Fragment>
                <div class="row no-gutters system-alerts-list">
                    <div class="alert-dismissible fade show">
                        {this.renderList()}
                    </div>
                </div>
                <div class="modal fade system-alerts-modal" id="system-alerts-modal" tabindex="-1" role="dialog" aria-labelledby="system-alerts-modal-title" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="system-alerts-modal-title">Notifications <span>{ this.state.alerts.length }</span></h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><svg role="img" aria-label="Close" class="system-alert-chevron"><use xlinkHref={ctspritepath + '#close'}></use></svg></button>
                            </div>
                            <div class="modal-body">
                                {this.renderModalList()}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export class Alerts extends Component {
    constructor(props) {
        super(props);

        const st = JSON.parse(sessionStorage.getItem('TransitTracker') || []);
        const alerts = st[this.props.type + 'Alerts'] || [];

        this.state = {
            alerts
        };

        window.addEventListener('storage', () => {
            const st = JSON.parse(sessionStorage.getItem('TransitTracker') || []);
            const alerts = st[this.props.type + 'Alerts'] || [];

            if (!this.state.alerts.length && alerts.length) {
                //console.log('IN ALERTS SETTING ALERTS FROM TRANSITTRACKER', st, alerts, this.props.type + 'Alerts');
                this.setState({
                    alerts
                });
            }
        });
    }

    componentDidMount = () => {
        //this.callApi();
    };

    callApi = () => {
        if ((this.props.type == 'route' || this.props.type == 'stop') && this.props.id) {
            PicsApi['getAlertsBy' + this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1)](this.props.id)
                .then(response => response.json())
                .then(results => {
                    let alerts = [];

                    if (results && results.alerts && results.alerts.length) {
                        results.alerts.forEach(alert => {
                            alerts.push(alert);
                        });
                    }

                    this.setState({
                        alerts
                    });
                })
                .catch(error => {
                    this.setState({
                        alerts: []
                    });
                });
        }
    };

    render() {
        if (!this.state.alerts || !this.state.alerts.length) {
            return null;
        }

        let alerts = this.state.alerts.filter(a => a.effect_name != routeAlertEffectName);

        if (!alerts || !alerts.length) {
            return null;
        }

        if (alerts.length > 1) {
            const effects = [...new Set(alerts.map(a => a.effect_name))].sort();

            return (
                <div class="alerts-container">
                    <div class="alerts-header">
                        <div class="alerts-header-icon">
                            <svg role="img" aria-label="Alert"><use xlinkHref={ctspritepath + '#alert'}></use></svg>
                        </div>
                        <div class="alerts-header-title">Alerts</div>
                    </div>
                    {effects.map(effect => {
                        return (
                            <AlertEffect type={this.props.type} effect={effect} alerts={alerts.filter(a => a.effect_name == effect)} />
                        );
                    })}
                </div>
            );
        }

        return (
            <div class="alerts-container">
                {alerts.map(alert => {
                    return (
                        <Alert type={this.props.type} alert={alert} isSingleAlert={true} />
                    );
                })}
            </div>
        );
    }
}

export class RouteAlerts extends Component {
    constructor(props) {
        super(props);

        const st = JSON.parse(sessionStorage.getItem('TransitTracker') || []);
        const alerts = st['routeAlerts'] || [];

        this.state = {
            alerts
        };

        window.addEventListener('storage', () => {
            const st = JSON.parse(sessionStorage.getItem('TransitTracker') || []);
            const alerts = st['routeAlerts'] || [];

            if (!this.state.alerts.length && alerts.length) {
                this.setState({
                    alerts
                });
            }
        });
    }

    componentDidMount = () => {
        //this.callApi();
    };

    callApi = () => {
        if (this.props.id) {
            PicsApi['getAlertsByRoute'](this.props.id)
                .then(response => response.json())
                .then(results => {
                    let alerts = [];

                    if (results && results.alerts && results.alerts.length) {
                        results.alerts.forEach(alert => {
                            alerts.push(alert);
                        });
                    }

                    this.setState({
                        alerts
                    });
                })
                .catch(error => {
                    this.setState({
                        alerts: []
                    });
                });
        }
    };

    renderAlert = (alert) => {
        return (
            <>
                <div class="route-alert-icon">
                    <svg role="img" aria-label="Alert"><use xlinkHref={ctspritepath + '#notifications-caution'}></use></svg>
                </div>
                <div class="route-alert-body">
                    <p>{alert.header_text}</p>
                    {alert.url ? (
                        <a href={alert.url} target="_blank">Learn more</a>
                    ) : null}
                </div>
            </>
        );
    };

    render() {
        if (!this.state.alerts || !this.state.alerts.length) {
            return null;
        }

        let alerts = this.state.alerts.filter(a => a.effect_name == routeAlertEffectName);

        if (!alerts || !alerts.length) {
            return null;
        }

        return (
            <div class="route-alerts-container">
                {alerts.map(alert => {
                    if (alert.url) {
                        return (
                            <a class="route-alert" href={alert.url} target="_blank">
                                {this.renderAlert(alert)}
                            </a>
                        );
                    }

                    return (
                        <div class="route-alert">
                            {this.renderAlert(alert)}
                        </div>
                    );
                })}
            </div>
        );
    }
}

class AlertEffect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        };
    }

    toggleExpand = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    };

    render() {
        const toggleIcon = ctspritepath + '#' + (this.state.isExpanded ? 'chevron-up' : 'chevron-down');

        return (
            <div class="alert-effect-container">
                <div class="alert-effect" onClick={this.toggleExpand}>
                    <div class="alert-effect-count">{this.props.alerts.length}</div>
                    <div class="alert-effect-name">{this.props.effect}</div>
                    <div class="alert-effect-toggle">
                        <svg role="img" aria-label="Chevron"><use xlinkHref={toggleIcon}></use></svg>
                    </div>
                </div>
                {this.state.isExpanded ? (
                    <div class="alert-effect-alerts">
                        {this.props.alerts.map(alert => {
                            return (
                                <Alert type={this.props.type} alert={alert} />
                            );
                        })}
                    </div>
                ) : null}
            </div>
        );
    }
}

export class Alert extends Component {
    constructor(props) {
        super(props);

        let alerts = [];
        if (props.alert) {
            alerts.push(props.alert);
        }

        this.state = {
            alerts,
            isExpanded: false
        };
    }

    componentDidMount = () => {
        this.callApi();
    };

    callApi = () => {
        if (this.props.type == 'system' || this.props.type == 'alert') {
            PicsApi.getAlerts()
                .then(response => response.json())
                .then(results => {
                    let alerts = [];

                    if (results && results.alerts && results.alerts.length) {
                        results.alerts.forEach(alert => {
                            if (alert.affected_services && alert.affected_services.services && alert.affected_services.services.length == 1 && !alert.affected_services.services[0].route_id) {
                                alerts.push(alert);
                            }
                        });
                    }

                    this.setState({
                        alerts
                    });
                })
                .catch(error => {
                    this.setState({
                        alerts: []
                    });
                });
        }
    };

    formatDate = (timestamp, isStart = false) => {
        if (!timestamp || isNaN(parseInt(timestamp))) {
            return 'Ongoing issue';
        }

        const date = new Date(parseInt(timestamp) * 1000);

        return (!isStart ? 'Until ' : '') + date.toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }) + ' at ' + date.toLocaleTimeString('en-US', { timeZone: 'America/Los_Angeles', timeStyle: 'short', hour12: true });
    };

    redirect = (e, type, data) => {
        e.preventDefault();

        if (data) {
            if (type == 'alert' && data.alert_id) {
                location.href = '/alert/' + encodeURIComponent(data.alert_id);
            }
        }
    };

    toggleExpand = () => {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    };

    render() {
        if (!this.state.alerts || !this.state.alerts.length) {
            return null;
        }

        const icon = ctspritepath + '#' + (this.state.isExpanded ? 'chevron-up' : 'chevron-down');

        if (this.props.type == 'system') {
            return (
                <div class="system-alerts-inpage">
                    <div class="d-table-cell"><svg role="img" aria-label="alert" class="system-alert-alert"><use xlinkHref={ctspritepath + '#alert'}></use></svg></div>
                    <div class="d-table-cell w-100">
                        <h6>{'System Wide Alert' + (this.state.alerts.length != 1 ? 's' : '')}</h6>
                        <p>All Routes Affected</p>
                        {this.state.isExpanded ? (
                            this.state.alerts.map(alert => {
                                return (
                                    <p><strong>{alert.effect_name}:</strong> {alert.header_text}</p>
                                );
                            })
                        ) : null}
                    </div>
                    <div class="d-table-cell"><svg role="img" aria-label="Chevron" class="system-alert-chevron" onClick={this.toggleExpand}><use xlinkHref={icon}></use></svg></div>
                </div>
            );
        }

        if (this.props.type == 'route' || this.props.type == 'stop') {
            const alert = this.state.alerts[0];
            let alertIcon = ctspritepath + '#alert';
            let isSnowAlert = false;

            if (alert.effect_name == 'Snow Route') {
                alertIcon = ctspritepath + '#snow';
                isSnowAlert = true;
            }

            return (
                <div class={'alert-inpage' + (this.props.isSingleAlert ? ' alert-inpage-single' : '')}>
                    <div class="alert-inpage-effect">{alert.effect_name}</div>
                    <div class="alert-inpage-id">Alert {alert.alert_id}</div>
                    <p>{this.formatDate(alert.effect_periods && alert.effect_periods.length && alert.effect_periods[0].effect_end ? alert.effect_periods[0].effect_end : '')}</p>
                    <p>{this.formatDate(alert.effect_periods && alert.effect_periods.length && alert.effect_periods[0].effect_start ? alert.effect_periods[0].effect_start : alert.created_dt, true)}</p>
                    <p>{alert.header_text}</p>
                    <p><a href="#" onClick={e => { this.redirect(e, 'alert', alert); }}>More details</a></p>
                </div>
            );
        }

        return null;
    }
}

function getAlerts() {
    if (localStorage.getItem('Alerts')) {
        let a = JSON.parse(localStorage.getItem('Alerts'));
        if (sessionStorage.getItem('Alerts')) {
            const b = JSON.parse(sessionStorage.getItem('Alerts'));
            a.dismissed = a.dismissed.concat(b.dismissed);
        }
        return a;
    }

    return { alerts: [], dismissed: [] };
}

function setAlerts(state) {
    const s = state.dismissed.filter(d => d.expires),
        l = state.dismissed.filter(d => !d.expires);

    sessionStorage.setItem('Alerts', JSON.stringify({ dismissed: s }));
    localStorage.setItem('Alerts', JSON.stringify({ alerts: state.alerts, dismissed: l }));
    window.dispatchEvent(new Event('storage'));
}


if (document.getElementById('system-alerts')) {
    ReactDOM.render(
        <AlertHeader />,
        document.getElementById('system-alerts')
    );
}

document.querySelectorAll('.system-alerts').forEach(container => {
    ReactDOM.render(
        <Alert type="system" />,
        container
    );
});

document.querySelectorAll('.alert-card').forEach(container => {
    ReactDOM.render(
        <Alert type="alert" />,
        container
    );
});